import _ from 'lodash'
import {
    FETCH_APPOINTMENTS,
    FETCH_APPOINTMENTS_START,
    FETCH_APPOINTMENTS_SUCCESS,
    FETCH_APPOINTMENTS_ERROR,
    ADD_UPDATE_APPOINTMENT,
    ADD_UPDATE_APPOINTMENT_START,
    ADD_UPDATE_APPOINTMENT_SUCCESS,
    ADD_UPDATE_APPOINTMENT_ERROR,
    SET_SELECTED_APPOINTMENT,
    SET_SELECTED_APPOINTMENT_SUCCESS,
    RESET_SELECTED_APPOINTMENT,
    ADD_UPDATE_APPOINTMENT_EVENT_SUCCESS,
    FETCH_RESOURCE_AVAILABILITY_SUCCESS,
    FETCH_RESOURCE_AVAILABILITY_ERROR,
    FETCH_RESOURCE_AVAILABILITY_ROSTER_START,
    DELETE_APPOINTMENT_EVENT_SUCCESS,
    CANCEL_APPOINTMENT_SUCCESS,
    SET_CALENDAR_RESOURCES,
    LOAD_APPOINMENT_CALENDAR_START,
    LOAD_APPOINMENT_CALENDAR_SUCCESS,
    LOAD_APPOINMENT_CALENDAR_ERROR,
    VIEW_REFERENCE_DOCS_SUCCESS,
    VIEW_REFERENCE_DOCS_ERROR,
    SET_APPOINTMENTS_PAGINATION,
    FETCH_APPOINTMENTS_BY_MIP_SUCCESS,
    FETCH_APPOINTMENTS_BY_MIP_ERROR,
    FETCH_APPOINTMENTS_BY_MIP_START,
    UPLOAD_APPOINTMENT_DOCUMENT_SUCCESS,
    UPLOAD_APPOINTMENT_DOCUMENT_ERROR,
    SET_CALENDAR_SLOT_EVENT,
    UPDATE_APPOINTMENT_NOTES,
    UPDATE_APPOINTMENT_AMR_NOTES,
    UPDATE_PATIENT_NOTES
} from '../../actions/receptionist/appointmentsAction';

const INIT_STATE = {
    error: "",
    loading: false,
    submitting: false,
    message: '',
    calendarResources: [],
    selectedAppointment: null,
    appointments: [],
    calendarEvents: [],
    calendarSlotEvent: "",
    roster: [],
    pagination: {
        currentPage: 1,
        pageSize: 20,
        totalPages: 0,
        totalItems: 0,
    },
    searchText: "",
    sortConditions: [{ sortBy: "appointment_id", dataType: "Long", sortType: "desc" }]
};

const appointmentsReducer = (state = INIT_STATE, action) => {
    let newState;
    let newSelectedAppointment;
    let newAppointments;
    let newCalendarEvents;
    let appointmentIndex;
    let eventIndex;
    switch (action.type) {
        case LOAD_APPOINMENT_CALENDAR_START:
        case FETCH_APPOINTMENTS_BY_MIP_START: {
            return { ...state, loading: true }
        }
        case LOAD_APPOINMENT_CALENDAR_SUCCESS: {
            return { ...state, loading: false }
        }
        case LOAD_APPOINMENT_CALENDAR_ERROR:
        case FETCH_APPOINTMENTS_BY_MIP_ERROR: {
            return {
                ...state,
                loading: false,
                appointments: [], // clear stale data
                error: action.payload || "Failed to fetch appointments",
            }
        }
        case SET_CALENDAR_RESOURCES: {
            return { ...state, calendarResources: action.calendarResources }
        }
        case FETCH_RESOURCE_AVAILABILITY_ROSTER_START: {
            return { ...state, error: '', message: '', roster: [] }
        }
        case FETCH_RESOURCE_AVAILABILITY_SUCCESS: {
            return { ...state, error: '', message: '', roster: action.roster }
        }
        case FETCH_RESOURCE_AVAILABILITY_ERROR: {
            return { ...state, error: '', message: '', roster: [] }
        }
        case FETCH_APPOINTMENTS_START: {
            return { ...state, error: '', message: '', loading: true, appointments: [], calendarEvents: [] };
        }
        case FETCH_APPOINTMENTS_SUCCESS: {
            return {
                ...state,
                error: '',
                message: '',
                loading: false,
                appointments: action.payload.appointments,
                calendarEvents: action.payload.calendarEvents
            };
        }
        case FETCH_APPOINTMENTS_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }
        case ADD_UPDATE_APPOINTMENT_START: {
            return { ...state, error: '', message: '', submitting: true, };
        }
        case ADD_UPDATE_APPOINTMENT_SUCCESS: {
            const { appointment, calendarEvent } = action.payload;
            newAppointments = [...state.appointments];
            // update appointments
            appointmentIndex = newAppointments.findIndex(obj => obj.appointmentId === appointment.appointmentId);
            if (appointmentIndex > -1) {
                let newAppointment = { ...appointment };
                delete newAppointment.events;
                let currentAppointment = { ...newAppointments[appointmentIndex], ...newAppointment };
                let newEvents = [...currentAppointment.events];
                let newEvent = appointment.events[0];

                let newModifiedEvents = appointment.events.map((newEvent) => {
                    const index = newEvents.findIndex(event => event.eventId === newEvent.eventId);

                    if (index > -1) {
                        newEvents.splice(index, 1, { ...newEvents[index], ...newEvent });
                    } else {
                        newEvents.push(newEvent);
                    }
                })

                currentAppointment.events = [...newEvents];
                newAppointments.splice(appointmentIndex, 1, currentAppointment);
            } else {
                newAppointments.push(appointment);
            }

            // update events
            newCalendarEvents = [...state.calendarEvents];
            if (appointment.status === "Created" && appointment.events.length > 1) {

                appointment.events.forEach(evt => {
                    eventIndex = newCalendarEvents.findIndex(event => event.eventId === evt.eventId);
                    if (eventIndex > -1) {
                        let calendarEvent = {
                            ...newCalendarEvents[eventIndex],
                            ...evt,
                            appointmentId: appointment.appointmentId,
                            resourceId: evt.machineId,
                            start: new Date(evt.start),
                            end: new Date(evt.end),
                            desc: "",
                            isAllDay: evt.allDay,
                        };
                        newCalendarEvents.splice(eventIndex, 1, calendarEvent);
                    } else {
                        // do nothing
                    }
                })
            } else {

                eventIndex = newCalendarEvents.findIndex(event => event.eventId === calendarEvent.eventId);
                if (eventIndex > -1) {
                    newCalendarEvents.splice(eventIndex, 1, calendarEvent);
                } else {
                    newCalendarEvents.push(calendarEvent);
                }
            }
            return { ...state, error: '', message: '', appointments: [...newAppointments], calendarEvents: [...newCalendarEvents], submitting: false, };
        }
        case ADD_UPDATE_APPOINTMENT_EVENT_SUCCESS: {
            const { event, calendarEvent } = action.payload;
            newSelectedAppointment = state.selectedAppointment ? { ...state.selectedAppointment } : null;
            newAppointments = [...state.appointments];
            // update appointments
            appointmentIndex = newAppointments.findIndex(obj => obj.appointmentId === event.appointmentId);
            if (appointmentIndex > -1) {
                let currentAppointment = { ...newAppointments[appointmentIndex] };
                let newEvents = [...currentAppointment.events];
                const index = newEvents.findIndex(obj => obj.eventId === event.eventId);
                if (index > -1) {
                    newEvents.splice(index, 1, { ...newEvents[index], ...event });
                } else {
                    newEvents.push(event);
                }
                currentAppointment.events = [...newEvents];
                newAppointments.splice(appointmentIndex, 1, currentAppointment);
            }
            //  update selectedAppointment
            if (newSelectedAppointment) {
                let newEvents = [...newSelectedAppointment.events];
                const index = newEvents.findIndex(obj => obj.eventId === event.eventId);
                if (index > -1) {
                    newEvents.splice(index, 1, {
                        ...newEvents[index],
                        ...event,
                        resourceId: event.machineId,
                        title: calendarEvent.title || 'NA',
                        key: `${newSelectedAppointment.mipId}-${event.machineId}-${newSelectedAppointment.eventId}-${event.eventId}`
                    });
                } else {
                    newEvents.push(event);
                }
                newSelectedAppointment.events = [...newEvents];
            }

            // update events
            newCalendarEvents = [...state.calendarEvents];
            eventIndex = newCalendarEvents.findIndex(event => event.eventId === calendarEvent.eventId);
            if (eventIndex > -1) {
                newCalendarEvents.splice(eventIndex, 1, calendarEvent);
            } else {
                newCalendarEvents.push(calendarEvent);
            }
            return {
                ...state,
                error: '',
                message: '',
                selectedAppointment: { ...newSelectedAppointment },
                appointments: [...newAppointments],
                calendarEvents: [...newCalendarEvents],
                submitting: false,
            };
        }
        case DELETE_APPOINTMENT_EVENT_SUCCESS: {
            // delete from appointments
            const { appointmentId, eventId } = action.payload;
            newAppointments = [...state.appointments];
            appointmentIndex = newAppointments.findIndex(obj => obj.appointmentId === appointmentId);
            console.log('appointmentIndex', appointmentIndex);
            if (appointmentIndex > -1) {
                let currentAppointment = { ...newAppointments[appointmentIndex] };
                let newEvents = [...currentAppointment.events];
                const index = newEvents.findIndex(obj => obj.eventId === eventId);
                if (index > -1) {
                    newEvents.splice(index, 1);
                }
                currentAppointment.events = [...newEvents];
                newAppointments.splice(appointmentIndex, 1);
            }
            console.log('newSelectedAppointment', newSelectedAppointment);

            // delete from calendarEvents
            newCalendarEvents = [...state.calendarEvents];
            eventIndex = newCalendarEvents.findIndex(event => event.eventId === eventId);
            console.log('eventIndex', eventIndex);
            if (eventIndex > -1) {
                newCalendarEvents.splice(eventIndex, 1);
            }
            return {
                ...state,
                error: '',
                message: '',
                selectedAppointment: null,
                appointments: [...newAppointments],
                calendarEvents: [...newCalendarEvents],
                submitting: false,
            };
        }
        case ADD_UPDATE_APPOINTMENT_ERROR: {
            return { ...state, submitting: false, error: action.error, message: '' };
        }
        case SET_SELECTED_APPOINTMENT_SUCCESS: {
            return { ...state, submitting: false, selectedAppointment: { ...action.appointment } };
        }
        case RESET_SELECTED_APPOINTMENT: {
            return { ...state, submitting: false, selectedAppointment: null };
        }
        case CANCEL_APPOINTMENT_SUCCESS: {
            newState = { ...state };
            newState.appointments = newState.appointments.filter((appointment) => appointment.appointmentId !== action.appointmentId);
            if (newState.selectedAppointment !== null) {
                if (newState.selectedAppointment.appointmentId === action.appointmentId) {
                    newState.selectedAppointment = null;
                }
            }
            newState.calendarEvents = newState.calendarEvents.filter((calendarEvent) => calendarEvent.appointmentId !== action.appointmentId);
            return { ...newState };
        }
        case UPLOAD_APPOINTMENT_DOCUMENT_SUCCESS: {
            newState = _.cloneDeep(state);

            const index = newState.appointments.findIndex(appointment => appointment.appointmentId === action.appointment.appointmentId);
            if (index === -1) {
                return newState;
            } else {
                let selectedAppointment = { ...newState.appointments[index] };
                selectedAppointment['documents'] = []
                console.log('selectedAppointment', selectedAppointment)
                selectedAppointment.documents && selectedAppointment.documents.push(_.cloneDeep(action.appointment));
                newState.appointments[index] = _.cloneDeep(selectedAppointment);
                return newState;
            }
        }
        case UPLOAD_APPOINTMENT_DOCUMENT_ERROR: {
            return { ...state, error: '', message: '', loading: false };
        }
        case VIEW_REFERENCE_DOCS_SUCCESS: {
            newState = _.cloneDeep(state);
            if (newState.selectedAppointment !== null) {
                newState.selectedAppointment.documents = _.cloneDeep(action.referralDocuments);
                return newState;
            } else {
                return state;
            }
        }
        case VIEW_REFERENCE_DOCS_ERROR: {
            return { ...state, loading: false, message: '' }

        }
        case SET_APPOINTMENTS_PAGINATION: {
            return { ...state, pagination: action.pagination };
        }
        case FETCH_APPOINTMENTS_BY_MIP_SUCCESS: {
            return {
                ...state,
                error: '',
                message: '',
                loading: false,
                appointments: _.cloneDeep(action.payload.appointments),
                sortConditions: action.payload.sortConditions.length > 0 ? [...action.payload.sortConditions] : []
            };
        }
        case SET_CALENDAR_SLOT_EVENT: {
            return {
                ...state,
                calendarSlotEvent: action.payload
            };
        }
        case UPDATE_APPOINTMENT_NOTES: {
            const newState = {
                ...state,
                appointments: state?.appointments.map(apt =>
                    apt?.appointmentId === action?.payload?.appointmentId
                        ? { ...apt, notes: action.payload.notes }
                        : apt
                ),
            };
            return newState
        }
        case UPDATE_APPOINTMENT_AMR_NOTES: {
            const incomingNotes = action.payload.notes || [];
            console.log(incomingNotes);

            const newState = {
                ...state,
                appointments: state?.appointments.map(apt => {
                    if (apt?.appointmentId !== action?.payload?.appointmentId) return apt;
                    const existing = apt.patientNotes || [];
                    const existingIds = new Set(existing.map(n => n.id));
                    // Only append notes whose id is not already present (avoid duplicates)
                    const trulyNew = incomingNotes.filter(n => !existingIds.has(n.id));
                    return { ...apt, patientNotes: [...existing, ...trulyNew] };
                }),
            };
            return newState;
        }
        case UPDATE_PATIENT_NOTES: {
            const newState = {
                ...state,
                appointments: state?.appointments.map(apt =>
                    apt?.patientId === action?.payload?.patientId
                        ? { ...apt, patientNotes: action.payload.notes?.filter(n => n.isAmr) }
                        : apt
                ),
            };

            return newState;
        }
        default:
            return state;
    }
}

export default appointmentsReducer;
